'use client'

import { EPageName } from "@/util/enum"
import SingleSwiper from "@/components/ui/swiper/SingleSwiper"
import ItemCardDetails, { ItemCardDetailsProps } from "./ItemCardDetails"
import { Button } from "@heroui/react"

type CrousalCuratedItemCard = {
    crouselData: ItemCardDetailsProps[],
    btn_text: string,
    btn_link: string,
}

const CrousalCuratedItemIndex = ({ crouselData, btn_text, btn_link }: CrousalCuratedItemCard) => {
    return (
        <>
            <div className="w-full space-y-8">
                <SingleSwiper pageName={EPageName?.THREESLIDE} crouselData={crouselData} renderItem={(item) => (
                    <ItemCardDetails
                        url={item.url}
                        alt_name={item.alt_name}
                        item_name={item.item_name}
                        item_description={item.item_description}
                        item_price={item.item_price}
                    />
                )} />
                <div className="flex justify-center">
                    <Button className="btn_responsive_cta silverblue_btn" onPress={() => window.open(btn_link || '/', '_blank')}>{btn_text}</Button>
                </div>
            </div>
        </>
    )
}

export default CrousalCuratedItemIndex